"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Properties = exports.attributeNestingSeparator = void 0;
exports.attributeNestingSeparator = '_&on;_';
var Properties;
(function (Properties) {
    Properties["TwitterClickId"] = "twclid";
    Properties["GoogleClickId"] = "ga_click_id";
    Properties["GoogleClientId"] = "ga_client_id";
    Properties["Fbp"] = "fbp";
    Properties["Fbc"] = "fbc";
    Properties["AnonymousId"] = "anonymousId";
    Properties["UserId"] = "userId";
    Properties["Latitude"] = "latitude";
    Properties["Longitude"] = "longitude";
    Properties["Gbraid"] = "gbraid";
    Properties["VwoUuid"] = "vwo_uuid";
    Properties["Tid"] = "tid";
    Properties["LeadOrigin"] = "lead_origin";
    Properties["LeadMedium"] = "lead_medium";
    Properties["LeadCampaign"] = "lead_campaign";
    Properties["LeadAudience"] = "lead_audience";
    Properties["LeadTargeting"] = "lead_targeting";
    Properties["LeadPageType"] = "lead_page_type";
    Properties["LeadType"] = "lead_type";
    Properties["LeadInfo"] = "lead_info";
    Properties["Label"] = "label";
    Properties["UsingDeltaAnalyticsSdk"] = "usingDeltaAnalyticsSDK";
    Properties["User_Id"] = "id_&on;_user";
    Properties["User_LoggedIn"] = "loggedIn_&on;_user";
    Properties["User_Type"] = "type_&on;_user";
    Properties["User_IsInstructor"] = "isInstructor_&on;_user";
    Properties["Member_Level"] = "level_&on;_member";
    Properties["Member_AccountType"] = "accountType_&on;_member";
    Properties["Member_Status"] = "status_&on;_member";
    Properties["Member_SinceDate"] = "sinceDate_&on;_member";
    Properties["Member_StartDate"] = "startDate_&on;_member";
    Properties["Member_ExpirationDate"] = "expirationDate_&on;_member";
    Properties["Member_CancellationDate"] = "cancellationDate_&on;_member";
    Properties["Lead_Origin"] = "origin_&on;_lead";
    Properties["Lead_Medium"] = "medium_&on;_lead";
    Properties["Lead_Campaign"] = "campaign_&on;_lead";
    Properties["Lead_Audience"] = "audience_&on;_lead";
    Properties["Lead_Targeting"] = "targeting_&on;_lead";
    Properties["Lead_PageType"] = "page_type_&on;_lead";
    Properties["Lead_Type"] = "type_&on;_lead";
    Properties["Lead_Info"] = "info_&on;_lead";
    Properties["Lead_AcquisitionDate"] = "acquisitionDate_&on;_lead";
    Properties["Lead_Tid"] = "tid_&on;_lead";
    Properties["EverflowTransactionId"] = "everflow_transaction_id";
    Properties["Email"] = "email";
    Properties["PhoneNumber"] = "phone";
    Properties["PhoneSupplied"] = "phone_supplied";
    Properties["PhoneOptIn"] = "phone_opt_in";
    Properties["VwoExperimentId"] = "vwo_experiment_id";
    Properties["VwoExperimentName"] = "vwo_experiment_name";
    Properties["VwoVariantId"] = "vwo_variant_id";
    Properties["VwoVariantName"] = "vwo_variant_name";
})(Properties = exports.Properties || (exports.Properties = {}));
